import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VModal from 'vue-js-modal'
import { BootstrapVue } from 'bootstrap-vue'
//import { VueReCaptcha } from 'vue-recaptcha-v3'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false
Vue.use(VModal, { dialog: true })
Vue.use(BootstrapVue)
/*Vue.use(VueReCaptcha, {
  siteKey: '6LdK8IUUAAAAACoVDRzjCYhdJIm_hPFKhEiAgyYn',
  loaderOptions: {
    autoHideBadge: true
  }
}) */

/* new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
}) */

import helpers from './helpers';

Vue.use(helpers);

const titlec = () => import("./components/uicomponents/title.vue");
const links = () => import("./components/uicomponents/links.vue");
const label = () => import("./components/uicomponents/label.vue");
const button = () => import("./components/uicomponents/button.vue");
const slider = () => import("./components/uicomponents/slider.vue");
const datafill = () => import("./components/uicomponents/datafill.vue");
const datepicker = () => import("./components/uicomponents/datepicker/datepicker.vue");
const dropdownsearch = () => import("./components/uicomponents/dropdownsearch.vue");
const employeepicture = () => import("./components/uicomponents/employeepicture.vue");
const dropdowncontainer = () => import("./components/uicomponents/dropdowncontainer.vue");

Vue.component('titlec', titlec);
Vue.component('links', links);
Vue.component('labelc', label);
Vue.component('slider', slider);
Vue.component('buttonc', button);
Vue.component('datafill', datafill);
Vue.component('datepicker', datepicker);
Vue.component('dropdownsearch', dropdownsearch);
Vue.component('employeepicture', employeepicture);
Vue.component('dropdowncontainer', dropdowncontainer);

const loginpanel = () => import("./components/login/loginpanel.vue");
const profilepanel = () => import("./components/profile/profilepanel.vue");

Vue.component('loginpanel', loginpanel);
Vue.component('profilepanel', profilepanel);




import $ from 'jquery'
Vue.use(require('vue-moment'));

Vue.directive('tooltip', {
  bind: function(el, binding, vnode) {
    el.addEventListener('mouseenter', function() {
      if(!binding.value) return;
      if (typeof binding.value === 'string') {
        window.app.ToggleTooltip({
          toggled: true,
          header: binding.value,
        });
      } else if (Object.prototype.toString.call(binding.value) == '[object Function]') { //for generated string you have to wrap them in functions example: GetAmountWrapper() { return  () => { return view.GetAmount(date) }}
        if(binding.value()){
          if(typeof binding.value() === 'string'){
            window.app.ToggleTooltip({
              toggled: true,
              header: binding.value(),
            });
          } else {
            window.app.ToggleTooltip(binding.value());
          }

        }

      } else {
        window.app.ToggleTooltip(binding.value);
      }
    });
    el.addEventListener('mousemove', function() {
      window.app.RepositionTooltip();
    });
    el.addEventListener('mouseleave', function() {
      window.app.ToggleTooltip({
        toggled: false,
        header: '',
        type: '',
        componentState: null,
      });
    });
  },
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
